import type { ReactNode } from 'react'
import { LogoMark } from '@/components/Logo'
import { ThemeToggleButton } from '@/components/ThemeToggleButton'

interface Props {
  children: ReactNode
  title: string
  subtitle?: string
}

/** Shared branded shell for every pre-login page (sign in, sign up, forgot password, 2FA) —
 *  the app's logo/theme are otherwise only visible once inside AppLayout, so a user never sees
 *  them before signing in without this. */
export function AuthLayout({ children, title, subtitle }: Props) {
  return (
    <div className="relative flex min-h-screen items-center justify-center bg-[var(--fl-bg)] p-4">
      <div className="absolute right-4 top-4">
        <ThemeToggleButton />
      </div>

      <div className="w-full max-w-sm space-y-6">
        <div className="space-y-2 text-center">
          <LogoMark size="lg" className="mx-auto" />
          <p className="text-xl font-bold tracking-tight text-[var(--fl-primary)]">Log My Spends</p>
        </div>

        <div className="rounded-2xl bg-[var(--fl-surface)] p-8 shadow-sm space-y-6">
          <div className="space-y-1">
            <h1
              className="text-2xl font-semibold text-[var(--fl-heading)]"
              style={{ fontFamily: '"Source Serif 4", Georgia, serif' }}
            >
              {title}
            </h1>
            {subtitle && <p className="text-sm text-[var(--fl-text-2)]">{subtitle}</p>}
          </div>
          {children}
        </div>
      </div>
    </div>
  )
}
